// 订单
const OrderDetail = () => import('@/views/order/Detail')
const OrderConfirm = () => import('@/views/order/Confirm')
const OrderReturn = () => import('@/views/order/Return')
const OrderLog = () => import('@/views/order/Log')
const PayResult = () => import('@/views/order/PayResult')

export default [
  {
    path: '/order/detail',
    component: OrderDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/order/confirm',
    component: OrderConfirm,
    meta: {
      title: '订单确认'
    }
  },
  {
    path: '/order/return',
    component: OrderReturn,
    meta: {
      title: '退团订单'
    }
  },
  {
    path: '/order/log',
    component: OrderLog,
    meta: {
      title: '订单记录'
    }
  },
  {
    path: '/order/payresult',
    component: PayResult,
    meta: {
      title: '支付结果'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/order.js